import { useEffect, useState } from "react";
import { localDateTime } from "../../lib/datetime";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { NeuButton, NeuCard, NeuInput } from "../../components/neu/Neu";
import { fxAuditLog, fxSettings, saveFxAnchor } from "../../api/fx";
import { useApiError } from "../../hooks/useApiError";
import { FxConverter } from "./FxConverter";

// إعدادات العملات: نقطة ارتكاز واحدة (دولار/دينار) وكل الأزواج تُحسب عبر الدولار.
export const CurrencySettings = () => {
  const { t } = useTranslation();
  const describe = useApiError();
  const [data, setData] = useState(null);
  const [rate, setRate] = useState("");
  const [log, setLog] = useState([]);

  const load = async () => {
    const settings = await fxSettings();
    setData(settings);
    setRate(settings.rate);
    setLog(await fxAuditLog());
  };

  useEffect(() => {
    load().catch(() => setData(null));
  }, []);

  const save = async () => {
    try {
      await saveFxAnchor(Number(rate));
      toast.success(t("fx.saved"));
      load();
    } catch (error) {
      toast.error(describe(error));
    }
  };

  if (!data) return null;

  return (
    <NeuCard className="grid gap-4 p-5 lg:col-span-2" data-testid="currency-settings">
      <div>
        <p className="label-xs">{t("fx.title")}</p>
        <p className="mt-1 text-xs text-muted-foreground">{t("fx.hint")}</p>
      </div>

      <div className="flex flex-wrap items-end gap-3">
        <div className="w-48">
          <p className="label-xs mb-2" dir="ltr">USD / IQD</p>
          <NeuInput type="number" step="0.01" data-testid="fx-anchor" value={rate} onChange={(e) => setRate(e.target.value)} />
        </div>
        <NeuButton variant="primary" data-testid="fx-save" disabled={!rate} onClick={save}>{t("app.save")}</NeuButton>
        <p className="text-[11px] text-muted-foreground">
          {t("fx.source")}: {t(`fx.sources.${data.rate_source}`)}
          {data.updated_at ? ` · ${localDateTime(data.updated_at)}` : ""}
          {data.updated_by ? ` · ${data.updated_by}` : ""}
        </p>
      </div>

      <FxConverter />

      <div className="grid gap-2" data-testid="fx-cross-rates">
        <p className="label-xs">{t("fx.crossRates")}</p>
        <div className="flex flex-wrap gap-2">
          {Object.entries(data.cross_rates).map(([code, value]) => (
            <span key={code} className="rounded-full px-3 py-1 text-[11px] font-bold shadow-neu-in" dir="ltr">
              {code} {value}
            </span>
          ))}
        </div>
      </div>

      {log.length ? (
        <div className="grid gap-1" data-testid="fx-audit">
          <p className="label-xs">{t("fx.auditTitle")}</p>
          {log.slice(0, 5).map((row) => (
            <p key={row.at} className="text-[11px] text-muted-foreground" dir="ltr">
              {localDateTime(row.at)} · {row.old_rate || "—"} → {row.new_rate} · {row.changed_by}
            </p>
          ))}
        </div>
      ) : null}
    </NeuCard>
  );
};
